export default __webpack_public_path__ + "static/media/ic_wbase_40.0c164311.svg";